import { Box, Grid, InputAdornment, Slider, Tooltip, Typography } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { ErrorMessage } from "formik"
import ColorPicker from "../../../colorpicker/ColorPicker"
import UploadFile from "../../../upload/upload"
import RenderInput from "./RenderInput"

const useStyles = makeStyles((theme) => ({
  sectionCard: {
    border: "1px solid #d7dbe0",
    borderRadius: 8,
    padding: theme.spacing(1.5),
    backgroundColor: "#ffffff",
  },
  sliderLabel: {
    color: "#98a1ad",
    fontSize: "1rem",
    marginBottom: theme.spacing(4),
  },
  sliderRoot: {
    color: "#f5b800",
    "& .MuiSlider-rail": {
      opacity: 1,
      backgroundColor: "#ead9a6",
    },
    "& .MuiSlider-track": {
      backgroundColor: "#f5b800",
    },
    "& .MuiSlider-thumb": {
      width: 14,
      height: 14,
      marginTop: -5,
    },
    "& .MuiSlider-valueLabelCircle": {
      width: 44,
      height: 44,
      borderRadius: "50%",
    },
  },
  errorMessage: {
    color: "#d50000",
    marginLeft: 0,
    marginBottom: "1rem",
    fontSize: "0.75rem",
  },
}))
function ValueLabelComponent(props) {
  const { children, open, value } = props

  return (
    <Tooltip open={open} enterTouchDelay={0} placement='top' title={value}>
      {children}
    </Tooltip>
  )
}

const defaultPrimary = "#FFEF35"
const playersScale = [50, 100, 250, 500, 1500, 2000, 5000, 15000]

const getPlayersFromIndex = (index) => playersScale[index] ?? playersScale[0]
const getIndexFromPlayers = (players) => {
  const parsed = Number(players)
  const exactIndex = playersScale.findIndex((value) => value === parsed)
  return exactIndex >= 0 ? exactIndex : 0
}
const sliderValueLabel = (index) => {
  const players = getPlayersFromIndex(index)
  return index === playersScale.length - 1 ? `+${players}` : `${players}`
}

function slugify(text) {
  return text
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/\s+/g, "-")
    .replace(/[^\w\-]+/g, "")
    .replace(/\-\-+/g, "-")
    .trim()
}

export default function ColorAndLogoForm(props) {
  const classes = useStyles()
  const {
    formField: { logo, primaryColor, plateformUrl, nbUsers },
    values,
    setFieldValue,
  } = props

  const onBlurUrl = (url) => {
    let newVal = url
    if (url.substring(url.length - 1, url.length) === "-") {
      newVal = url.substring(0, url.length - 1)
    }
    setFieldValue(plateformUrl.name, newVal)
  }

  const handleNbUsersChange = (_e, index) => setFieldValue(nbUsers.name, getPlayersFromIndex(index))

  return (
    <Box pt={1}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <RenderInput
            name={plateformUrl.name}
            label=''
            placeholder='URL du jeu*'
            onChange={(e) => setFieldValue(plateformUrl.name, slugify(e.target.value))}
            onBlur={() => onBlurUrl(values.PlateformUrl)}
            InputProps={{
              endAdornment: <InputAdornment position='end'>.pronosticgames.fr</InputAdornment>,
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <ColorPicker
            variant='outlined'
            label='Couleur principale*'
            onChange={(color) => {
              setFieldValue(primaryColor.name, color)
            }}
            fullWidth
            value={values.PrimaryColor || defaultPrimary}
          />
        </Grid>

        <Grid item xs={12}>
          <Typography className={classes.sliderLabel}>Nombre de joueurs*</Typography>
          <Slider
            value={getIndexFromPlayers(values.NbUsers)}
            onChange={handleNbUsersChange}
            min={0}
            max={playersScale.length - 1}
            step={1}
            valueLabelDisplay='on'
            valueLabelFormat={sliderValueLabel}
            ValueLabelComponent={ValueLabelComponent}
            className={classes.sliderRoot}
          />
        </Grid>

        <Grid item xs={12}>
          <UploadFile
            name={logo.label}
            value={values.Logo}
            previewWidth={128}
            layout='inline'
            showFilename={false}
            onChange={(url) => {
              setFieldValue(logo.name, url)
            }}
          />
        </Grid>

        <ErrorMessage component='p' name={logo.name} className={classes.errorMessage} />
      </Grid>
    </Box>
  )
}
